import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../ui/table";
import IosSwitch from "../../../../IosSwitch/IosSwitch";
import { Badge } from "../../../../ui/badge";

const getStatusBadge = (status) => {
  switch (status) {
    case "connected":
      return (
        <Badge className="bg-green-100 text-green-800 hover:bg-green-100 border-none">
          Connected
        </Badge>
      );
    default:
      return (
        <Badge className="bg-gray-100 text-gray-800 hover:bg-gray-100 !border-none">
          Disconnected
        </Badge>
      );
  }
};

const PracticeConnectionTable = ({
  localSelectedPractices,
  handleClickLocalPractice,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow className="bg-thead-connections">
          <TableHead className="font-medium text-gray-600">
            Practice Name
          </TableHead>
          <TableHead className="font-medium text-gray-600">State</TableHead>
          <TableHead className="font-medium text-gray-600">Status</TableHead>
          <TableHead className="font-medium text-gray-600 text-right">
            Connection
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {localSelectedPractices.map((practice) => (
          <TableRow key={practice.id} className="hover:bg-gray-50">
            <TableCell className="font-medium">{practice.name}</TableCell>
            <TableCell>{practice.state}</TableCell>
            <TableCell>
              <div className="w-full">
                {getStatusBadge(practice.isConnected ? "connected" : "")}
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center justify-end gap-2">
                <span className="text-sm text-gray-600">
                  {practice?.isConnected ? "On" : "Off"}
                </span>
                <IosSwitch
                  checked={practice?.isConnected}
                  onClick={() => {
                    handleClickLocalPractice(practice._id);
                  }}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PracticeConnectionTable;
